import { useStore } from '../store/store.ts';
import { openQuickNote } from '../features/observations/QuickNoteModal.tsx';

export function Topbar({ onQuickAdd, onExport }: { onQuickAdd: () => void; onExport: () => void }) {
  const teacher = useStore((s) => s.settings.teacher);

  return (
    <header class="topbar">
      <div class="logo">
        <div class="logoMark">JC</div>
        <span>Mon journal de classe</span>
        <span class="muted">{teacher}</span>
      </div>

      <div class="topActions">
        <button class="btn ghost desktop" onClick={onExport}>
          Sauvegarder
        </button>
        {/* Not hidden on small screens, no more than the quick note is: the
            tablet in the classroom is where a note has to be one tap away, and
            printing from the phone was simply impossible before. */}
        <button class="btn soft" onClick={() => window.print()}>
          Imprimer
        </button>
        <button class="btn soft" onClick={openQuickNote}>
          ✏️ Note rapide
        </button>
        <button class="btn primary" onClick={onQuickAdd}>
          + Ajouter
        </button>
      </div>
    </header>
  );
}
